export const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/home.component'),
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: () => import('@/views/checkout/checkout.component'),
  },
  {
    path: '/confirmednumber',
    name: 'confirmednumber',
    component: () => import('@/views/confirmed-number/confirmed-number.component'),
  },
  {
    path: '/getnumber',
    name: 'getnumber',
    component: () => import('@/views/get-number/get-number.component'),
  },
  {
    path: '/verifyemail',
    name: 'verifyemail',
    component: () => import('@/views/verifyemail/verifyemail.component'),
  },
  {
    path: '/checkoutconfirmation',
    name: 'checkoutconfirmation',
    component: () => import('@/views/checkout-confirmation/checkout-confirmation.component'),
  },

  {
    path: '/inviteCheckout',
    name: 'inviteCheckout',
    component: () => import('@/views/invite-checkout/invite-checkout.component'),
  },
  {
    path: '/request-access',
    name: 'request-access',
    component: () => import('@/views/request-access/request-access.component'),
  },
  {
    path: '*',
    redirect: '/error',
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('@/views/error/error.component'),
  },
];
